import { IAttribute, IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Owned } from '../base/named';

@Metamodel.model({})
export class ExecuteSSISPackageChildPackageConfig extends Owned {
    public static readonly MODEL: IModel;
    public static readonly PACKAGE_PATH: IAttribute;
    public static readonly INLINE_PACKAGE_NAME: IAttribute;
    public static readonly PACKAGE_CONTENT: IAttribute;
    public static readonly PACKAGE_LAST_MODIFIED_DATE: IAttribute;

    @Metamodel.attribute({
        association: 'PACKAGE_PATH'
    })
    public packagePath: string;

    @Metamodel.attribute({
        association: 'INLINE_PACKAGE_NAME'
    })
    public inlinePackageName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PACKAGE_CONTENT'
    })
    public packageContent?: string;

    @Metamodel.attribute({
        association: 'PACKAGE_LAST_MODIFIED_DATE'
    })
    public packageLastModifiedDate?: string;

    public constructor(packagePath?: string) {
        super();
        this.packagePath = packagePath;
    }
}
